import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import AuthService from "../services/auth.service";
import { useAuth } from "../context/AuthContext";

//const user = AuthService.getCurrentUser();

const Logout = () => {
  
  const {user,logout} = useAuth();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  
  useEffect(()=>{

    if(!user){
      navigate('/login');
    } else {
      AuthService.logout().then(
            (response) => {
              //localStorage.removeItem("cmx_user");
              console.log('logging out...')
              //navigate("/home");
              logout();
              navigate('/login');
            },
            (error) => {
              

              const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();

              setLoading(false);
              setMessage(resMessage);

            }
      );
    }

  },[])
  
  
  
  

  return (
      <>
        {message ? (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
        ) : 

        (
            <div className="form-group">
              <div className="alert alert-info" role="alert">
                <p>Logging out...</p>
              </div>
            </div>
        )}
          
        
      </>
  );
     
}; 

  


export default Logout;
